import { createRoute, redirect } from '@tanstack/react-router';

import { meRepository } from '@web/data/repositories';
import { DocsPage } from '@web/ui/docs/views';

import { protectedRoute } from './root_routes';

/**
 * `/docs` aggregates the OpenAPI surface of every backend. The API
 * documentation reveals internal paths/schemas, so the route is gated
 * behind authentication + a privileged role check:
 *   - staff (`isStaff`) — internal Voll engineers, bypass org checks.
 *   - org `owner` — the founder/lead of any org the caller belongs to.
 *
 * Same gate in dev and prod: hitting `/docs` requires a real Cognito
 * login. Non-privileged authenticated users get bounced to `/`.
 * Logged-out users hit `protectedRoute`'s redirect to `/login` first.
 */
export const docsRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: '/docs',
  component: DocsPage,
  beforeLoad: async () => {
    // Network/API failure (`null`) — fail closed and bounce the user back to /
    // rather than surfacing an unhandled error mid-navigation.
    const me = await meRepository.getMe().catch(() => null);
    const isPrivileged = me !== null && (me.isStaff || me.orgs.some((o) => o.role === 'owner'));
    if (!isPrivileged) redirect({ throw: true, to: '/' });
  },
});
